var moment = require('moment');

// Shared 16-15 payroll cycle convention: a 'YYYY-MM' periode means the
// cycle that STARTS on the 16th of that month and ends the 15th of the
// next (e.g. '2026-10' = 16 Oct to 15 Nov) -- same convention already used
// server-side everywhere periode_start/periode_end appear. Lets every
// "Periode Start" + "Periode End" filter collapse into one <input
// type="month"> like the one already on the employee profile's Absen tab.
export function periodeToRange(periode) {
  if (!periode) {
    return { start: '', end: '' };
  }
  var start = moment(periode + '-16', 'YYYY-MM-DD');
  var end   = start.clone().add(1, 'month').subtract(1, 'day');
  return {
    start: start.format('YYYY-MM-DD'),
    end: end.format('YYYY-MM-DD'),
  };
}

export function defaultPeriode() {
  var today = moment();
  return (today.date() >= 16) ? today.format('YYYY-MM') : today.clone().subtract(1, 'month').format('YYYY-MM');
}
